import { useEffect, useMemo } from "react";
import useAgentStore from "../pages/useAgentStore";

/**
 * Resolve avatar URL and display name for a registered context agent from the agents list.
 */
export default function useRegisteredAgentProfile(agentName) {
  const agents = useAgentStore((state) => state.agents);

  useEffect(() => {
    if (!agentName) {
      return;
    }
    if (agents.length === 0) {
      useAgentStore.getState().fetchAgents();
    }
  }, [agentName, agents.length]);

  return useMemo(() => {
    if (!agentName) {
      return { displayName: "", avatarUrl: null };
    }
    const match = agents.find((agent) => agent.name === agentName);
    return {
      displayName: match?.name || agentName,
      avatarUrl: match?.avatarUrl || null,
    };
  }, [agents, agentName]);
}
